// Requests
import PostCall from "./CommonApi";

const SaveOrder = (props) => {
    let url = "/v1/ovra/transaction/SaveOrder";
    let requestObject = props;
    return PostCall(url,requestObject);
};

export default SaveOrder;
